import React, { useEffect } from "react";
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaGithub,
  FaArrowDown,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";

function Artikel1() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section id="blog1" className="mb-24 mt-28">
      <div className="container relative flex">
        <div className="fixed mx-4  hidden w-full md:left-0 lg:block">
          <div className="">
            <div className="w-1 items-center p-4 pt-0">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://instagram.com/dyy_rul07?igshid=YmMyMTA2M2Y="
              >
                <FaInstagram
                  size={18}
                  className="mx-auto text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/profile.php?id=100078541170035&mibextid=ZbWKwL"
              >
                <FaFacebook
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://twitter.com/ElhadiKhair?t=tuXc8rDOhZSmBBP90kIgnA&s=09"
              >
                <FaTwitter
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/khairul-hadi-a51598222"
              >
                <FaLinkedin
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
            <div className="w-1 items-center p-4">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://github.com/dyyrul"
              >
                <FaGithub
                  size={18}
                  className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                />
              </a>
            </div>
          </div>
        </div>
        <div className=" w-full rounded-lg border px-6 py-10 shadow-lg lg:ml-10">
          <h1 className="mb-4 pl-4 text-2xl font-semibold leading-10 text-primary md:text-4xl">
            Mastering Programming: Tips and Strategies for Success in the
            Digital World
          </h1>
          <hr className="mb-5 mt-5" />
          <p className=" md:tex mt-2  text-lg leading-10 text-slate-500 md:leading-[50px]">
            Programming has become an increasingly important skill in today's
            digital era. In the rapidly evolving world of information
            technology, mastering programming can be the key to unlocking
            various career and business opportunities. Whether you're a beginner
            just starting out or an experienced programmer, there are several
            tips and strategies that can help you succeed in programming. In
            this article, we will explore some important tips and strategies to
            achieve success in the world of programming.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              1. Create a clear learning plan
            </h2>
            The first important step in learning programming is to create a
            clear learning plan. Programming is a broad and complex field, so
            it's important to set clear learning goals and create a structured
            plan. You can choose the programming language you want to learn,
            determine the learning resources to be used, set a consistent
            learning schedule, and measure your progress regularly.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              2. Master the Basic Concepts
            </h2>
            Mastering the basic concepts in programming is a crucial step to
            becoming a successful programmer. You need to understand concepts
            such as variables, data types, mathematical operations, logic,
            loops, and decision making. Understanding these concepts will
            provide a strong foundation for understanding any programming
            language and enable you to efficiently solve problems.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              3. Consistent Practice
            </h2>
            Practice is the key to mastering programming. Once you understand
            the basic concepts, it's important to practice consistently in
            writing code. Try creating simple projects, solving programming
            challenges, or contributing to open source projects. Consistent
            practice will help you gain a deeper understanding of the
            programming language you're learning, sharpen your debugging skills,
            and build confidence in programming.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              4. Learn from Reliable Sources
            </h2>
            In the world of programming, quality learning resources are crucial.
            There are many online learning resources such as tutorials, courses,
            forums, and documentation, but not all of them are reliable. Choose
            reputable learning sources, such as official websites of programming
            language developers, well-known books, or trusted online learning
            platforms. Make sure the learning sources provide quality,
            up-to-date content that matches your level of understanding.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              5. Seek Help and Collaborate
            </h2>
            Programming is a dynamic and complex field, and you may encounter
            challenges and difficulties during the learning process. Therefore,
            it's important to seek help and collaborate with fellow programmers.
            You can join programming communities, participate in online forums,
            or join coding meetups to seek help, share knowledge, and
            collaborate with other programmers.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              6. Keep Learning and Stay Updated
            </h2>
            Programming is a constantly evolving field, and it's important to
            keep learning and stay updated with the latest trends and
            technologies. Stay curious, explore new programming languages,
            frameworks, and tools, and keep yourself updated with industry news
            and updates. Continuous learning and staying updated will help you
            stay relevant and competitive in the fast-paced world of
            programming.
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              Conclusion:
            </h2>
            Mastering programming requires consistent effort, practice, and
            continuous learning. By creating a clear learning plan, mastering
            the basic concepts, practicing consistently, learning from reliable
            sources, seeking help and collaborating with fellow programmers, and
            staying updated with the latest trends, you can increase your
            chances of success in the world of programming. Remember to stay
            persistent, be patient with yourself, and never stop learning in
            your programming journey. Happy coding!
          </p>
          <div className="w-full px-4">
            <NavLink to="/" ClassName="active">
              <button className=" mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                Back To Home
              </button>
            </NavLink>
          </div>
        </div>

        <div className="mx-4 hidden lg:block">
          <div className="mx-auto mb-5 max-w-full rounded-lg border text-center shadow-lg ">
            <h1 className=" mb-4 py-5 text-xl font-bold text-primary md:text-2xl">
              Other Articles
            </h1>
            <hr className="py-4" />
            <div className="animate-bounce pb-6 ">
              <FaArrowDown size={20} className="mx-auto " />
            </div>
          </div>

          <div class="sm:w-50 mb-10 overflow-hidden rounded-lg bg-white shadow-lg sm:mb-0 md:w-80 lg:w-72">
            <img src="./img/blog1.jpg" alt="Blog 1" class="w-full" />
            <div class="px-6 py-4">
              <div class="mt-6 text-xl font-semibold text-gray-700">
                Advanced Error Handling Techniques for Professional Developers
              </div>
              <p class="mt-4 text-base text-slate-600">
                As software applications grow in complexity and scale, it
                becomes increasingly important for professional developers to
                implement robust error handling.....
              </p>
              <div className="w-full px-4">
                <NavLink to="/artikel2">
                  <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                    Read More
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Artikel1;
